import { Component } from '@angular/core';

@Component({
    selector: 'app-icon-cpu-unlock',
    templateUrl: './icon-cpu-unlock.component.pug',
    styleUrls: ['./icon-cpu-unlock.component.less']
})
export class IconCpuUnlockComponent {
    value: string = '';

    constructor(
    ) {
    }

    setValue(value: any) {
        this.value = value.toString();
    }
}
